import { chatbotApi } from '@/apis/chatbot';

// let runtimeSessionId = '';

// function getSessionId() {
//   return runtimeSessionId || '';
// }

// function saveSessionId(id) {
//   if (id) runtimeSessionId = id;
// }

// export function clearChatSessionId() {
//   runtimeSessionId = '';
// }

async function* readSSE(response) {
  const decoder = new TextDecoder();
  let buffer = '';

  for await (const rawChunk of response.body) {
    buffer += decoder.decode(rawChunk, { stream: true });

    const parts = buffer.split('\n\n');
    buffer = parts.pop();

    for (const part of parts) {
      const line = part.trim();
      if (!line.startsWith('data:')) continue;

      const jsonStr = line.slice('data:'.length).trim();
      if (!jsonStr) continue;

      try {
        yield JSON.parse(jsonStr);
      } catch {
        console.error('Malformed event:', jsonStr);
      }
    }
  }

  if (buffer.trim().startsWith('data:')) {
    try {
      yield JSON.parse(buffer.slice('data:'.length).trim());
    } catch {
      console.error('Malformed event:', buffer);
    }
  }
}

export async function sendMessageStream(payload, callbacks = {}) {
  const { onSession, onDelta, onDone, onError } = callbacks;

  // const sessionId = getSessionId();
  const body = {
    ...payload,
    // ...(sessionId && { session_id: sessionId }),
  };

  const response = await chatbotApi.fetchMessageStream(body);

  let fullText = '';

  for await (const event of readSSE(response)) {
    switch (event.type) {
      case 'session':
        // saveSessionId(event.session_id);
        if (onSession) onSession(event);
        break;

      case 'delta':
        fullText += event.text;
        if (onDelta) onDelta(event.text, fullText);
        break;

      case 'done':
        if (onDone) onDone(event, fullText);
        break;

      case 'error':
        if (onError) onError(event);
        throw new Error(`Server error: ${event.message}`);
    }
  }

  return fullText;
}
